import { useDispatch } from 'react-redux';
import { showModalAction } from 'Store/modules/app/actions';
import { PDF_MODAL } from 'Constants/modals';
import { TaxScreenType } from 'Types/common';
import View from './view';

const Validation = ({ tax }: TaxScreenType): JSX.Element => {
  const dispatch = useDispatch();
  const handleShowDraft = (pdfFile: string): void => {
    dispatch(
      showModalAction({
        options: { type: PDF_MODAL, pdf: pdfFile },
      })
    );
  };

  return <View tax={tax} handleShowDraft={handleShowDraft} />;
};

export default Validation;
